import React, { useState, useEffect } from "react";

const Loading = () => {
  const [text, setText] = useState("loading");
  useEffect(() => {
    const clear = setInterval(loading, 500);
    return () => clearInterval(clear);
  }, []);
  const loading = () => {
    setText(prevtext => {
      if (prevtext.length < 10) {
        return prevtext.concat(".");
      } else {
        return prevtext.slice(0, -3);
      }
    });
  };
  return <div className="loading">{text}</div>;
};

export default Loading;
